export enum CaseServiceFilterOptions {
    None = 1,
    DeletedCaseServices = 2
}